import React from 'react';
import { Router, Switch, Route } from 'react-router-dom'
// import './App.css';
import Header from './Reusables/Header';
import Footer from './Reusables/Footer';
import WritersBlog from './Components/Blog/WritersBlog';
import IndividualBlog from './Components/Blog/IndividualBlog/IndividualBlog';
import LandingPage from './Components/LandingPage/LandingPage'
import ScrollToTop from './Components/ScrollToTop';
import OurWork from './Components/Our Work/OurWork';
import Auditions from './Components/Auditions/Auditions';
//import Auditionsdummy from './Components/Auditions/Auditionsdummy';
import Error from './Components/404';
import ReactGA from 'react-ga';
import  {History}  from './History'



ReactGA.initialize('G-L4SPWWQD5X1');
var ids;
class App extends React.Component {
  state = {
    id: '',
    type:''
  }
  componentDidMount=()=>{
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.setState({
      id: '',
      type:'streetplay'
    })
  }
  getBlog = (blog) => {
    ids=blog
    this.setState({
      id: blog
    })
  }
  getType = (type) => {
    this.setState({
      type
    })
  }

  render() {
    const {  type } = this.state

    return (
      <Router history={History}>
        <ScrollToTop />
        <div className="App">
          <div className="content">
          <Header getType={this.getType}/>
                <Switch>
                  <Route exact path='/' render={() => <LandingPage type={type}   getType={this.getType}/>} />
                  <Route exact path="/blogs" render={() => <WritersBlog getId={this.getBlog} />} />
                  <Route exact path="/blogs/:name/:id" render={() => <IndividualBlog id={ids} getId={this.getBlog} />} />
                  <Route exact path="/work" render={() => <OurWork type={type} />}/>
                  <Route exact path="/auditions-2022" render={() => <Auditions type={type} getType={this.getType}/>}/>
                  {/*<Route exact path="/dummy" render={() => <Auditionsdummy  />}/> */}
                  <Route exact path="*" render={() => <Error  />}/>
                </Switch>
          </div>
          <Footer />
        </div>
      </Router >

    );
  }
}




export default (App);



